export const QueryDropDownReasons = [
  { label: "DX code missing", value: "DX code missing" },
  {
    label: "Medical necessity criteria not met",
    value: "Medical necessity criteria not met",
  },
  { label: "Non preferred drug", value: "Non preferred drug" },
  {
    label: "Outside location / Home infusion",
    value: "Outside location / Home infusion",
  },
  { label: "Provider issue", value: "Provider issue" },
  { label: "Step therapy not followed", value: "Step therapy not followed" },
  { label: "This DOS was rescheduled", value: "This DOS was rescheduled" },
  { label: "Dosage issue", value: "Dosage issue" },
  { label: "Patient-owned inventory", value: "Patient-owned inventory" },
  { label: "Drug not scheduled", value: "Drug not scheduled" },
  { label: "Clinicals missing", value: "Clinicals missing" },
  { label: "Treatment planning issue", value: "Treatment planning issue" },
  { label: "Insurance issue", value: "Insurance issue" },
];

export const DenialDropDownReasons = [
  {
    label: "Medical necessity criteria not met",
    value: "Medical necessity criteria not met",
  },
  { label: "Not a preferred drug", value: "Not a preferred drug" },
];

export const QueryResolutionDropDownReasons = [
  { label: "Drug Changed", value: "Drug Changed" },
  { label: "Drug Removed", value: "Drug Removed" },
  { label: "Treatment Plan Changed", value: "Treatment Plan Changed" },
  { label: "Clinicals Added", value: "Clinicals Added" },
  { label: "Insurance Updated", value: "Insurance Updated" },
  { label: "Dosage Updated", value: "Dosage Updated" },
];
